<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-branch`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.5513 1.42188C11.3501 1.42188 11.9976 2.06936 11.9976 2.86816C11.9973 3.64888 11.3789 4.28343 10.605 4.31152L10.1958 4.87891C9.6367 5.65457 9.27689 6.16562 8.79932 6.53809C8.74323 6.58182 8.68562 6.62341 8.62744 6.66406C8.68578 6.70482 8.74308 6.74716 8.79932 6.79102C9.27692 7.1635 9.63665 7.67447 10.1958 8.4502L10.604 9.0166C11.3785 9.0442 11.9976 9.67968 11.9976 10.4609C11.9973 11.2595 11.3499 11.9072 10.5513 11.9072C9.75293 11.9069 9.10528 11.2593 9.10498 10.4609C9.10498 10.1921 9.17931 9.94027 9.30713 9.72461L9.00635 9.30762C8.39664 8.46176 8.17121 8.16151 7.89795 7.94824C7.63855 7.74593 7.34265 7.5941 7.02686 7.50195C6.70833 7.40905 6.35075 7.3982 5.40674 7.39746C5.3635 7.39745 5.31956 7.39844 5.2749 7.39844H4.66162C4.37987 8.03182 3.74607 8.47461 3.0083 8.47461C2.00913 8.47436 1.19897 7.66323 1.19873 6.66406C1.19897 5.66489 2.00913 4.85474 3.0083 4.85449C3.74679 4.85449 4.38224 5.29645 4.66357 5.93066H5.40674C6.35075 5.92993 6.70833 5.92005 7.02686 5.82715C7.34267 5.735 7.63853 5.58318 7.89795 5.38086C8.17124 5.1676 8.39664 4.86734 9.00635 4.02148L9.30713 3.60254C9.17967 3.38717 9.10506 3.13653 9.10498 2.86816C9.10498 2.06954 9.75272 1.42218 10.5513 1.42188Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillBranch',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
